import React from 'react';
import { Popup } from 'semantic-ui-react';

interface TooltipInfoProps {
    content: string;
    trigger: JSX.Element;
    position?: 'top left' | 'top right' | 'bottom right' | 'bottom left' |
        'right center' | 'left center' | 'top center' | 'bottom center';
    size?: 'mini' | 'tiny' | 'small' | 'large' | 'huge';
}

const TooltipInfo: React.FC<TooltipInfoProps> = ({ content, trigger, position = 'top left', size = 'small' }) => (
    <Popup
        content={content}
        trigger={trigger}
        position={position}
        size={size}
        inverted
    />
);

export default TooltipInfo;
